import React from "react";
import { IconButton } from "@material-ui/core";
import { useStyles, style } from '../SignatureScreenStyles'
import { Icon, Table, Tooltip } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
//import { employeeById } from 'app/reducers';
import * as SignatureActions from '../../../actions/SignatureActions';

const TableScreen = (props) => {
    let { dtsize } = props;
    const classes = useStyles();
    const dispatch = useDispatch();

    const {
        isLoadingSignature,
        isDeleting,
        isSaving,
        listContrat,
        listCategory,
        listSignature,
        pagination
    } = useSelector(state => state.SignatureReducer);


    const dataSource = listSignature.map(
        (record) => {
            return {
                'key': record.idSignatory,
                'idSignatory': record.idSignatory,
                'employeeName': record.employeeName,
                'categoryName': record.categoryName,
                'contractId': record.contractId,
                'contractName': record.contractName,
                'idType': record.idType,
                'signatoryType': record.signatoryType
            }
        }
    );

    const paginationTable =
    {
        defaultCurrent: 1,
        defaultPageSize: 25,
        current: pagination.current,
        pageSize: pagination.pageSize,
        total: pagination.total,
        showSizeChanger: true,
        pageSizeOptions: ['25', '50', '100'],
        showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
    }
    const handleTableChange = (pagination, filters, sorter) => {
        let obj = {
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            column: Object.keys(sorter).length > 0 ? sorter.field : undefined,
            order: Object.keys(sorter).length > 0 ? (sorter.order === "ascend" ? 'ASC' : 'DESC') : undefined
        }

        dispatch(SignatureActions.savePagination(obj));

        dispatch(SignatureActions.getListSignatures({
            offset: (pagination.current - 1) * pagination.pageSize,
            limit: pagination.pageSize,
            sortColumn: Object.keys(sorter).length > 0 ? sorter.field : undefined,
            sortDir: Object.keys(sorter).length > 0 ? (sorter.order === "ascend" ? 'ASC' : 'DESC') : undefined,
            EmployeeId: props.employeeId.join(','),
            IdCategory: props.categoryId.join(','),
        }))
    }

    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'employeeName',
            key: 'employeeName',
            sorter: true,
            ellipsis: true,
            width: 500

        },
        {
            title: 'Puesto',
            dataIndex: 'categoryName',
            key: 'categoryName',
            sorter: true,
            ellipsis: true,
            width: 500

        },
        {
            title: 'Contrato',
            dataIndex: 'contractName',
            key: 'contractName',
            sorter: true,
            ellipsis: true,
            width: 400
        },
        {
            title: 'Tipo Firmante',
            dataIndex: 'signatoryType',
            key: 'signatoryType',
            sorter: true,
            ellipsis: true,
            width: 200
        },
        {

        },
        {
            title: 'Acciones',
            key: 'action',
            dataIndex: 'idSystem',
            fixed: 'right',
            width: 120,
            render: (text, record) => (
                <div className={classes.buttons}>
                    <Tooltip title="Eliminar">
                        <IconButton className={classes.deleteIcon} onClick={() => props.showConfirmDelete(record)}>
                            <Icon type="delete" />
                        </IconButton>
                    </Tooltip> 
                    <Tooltip title="Editar">
                        <IconButton className={classes.editIcon} onClick={() => props.editSystem(record)} >
                            <Icon type={"edit"} />
                        </IconButton>
                    </Tooltip>

                </div>
            )
        }
    ];

    return (
        <div>
            <Table
                loading={isLoadingSignature}
                columns={columns}
                dataSource={dataSource}
                pagination={paginationTable}
                scroll={dtsize}
                size={"small"}
                onChange={handleTableChange}
            />
        </div>
    )
}

export default TableScreen;